import { Subscription } from 'rxjs';
import { AuthorityService } from '@root/shared/business-sevice/authority.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { TranslateService } from '@root/shared/service/translate.service';
import { InjectorService } from '@root/injector.service';
import { takeUntil } from 'rxjs';
import { MemberService } from '@root/router/index/member.service';

/**
 * 装饰器模块
 */
type PropDecorator = (target: any, propName: string) => void;
function propDecoratorFactory<T, D>(name: string, callback: (v: T) => D): PropDecorator {
  function propDecorator(target: any, propName: string) {
    const privatePropName = `$__${propName}`;

    Object.defineProperty(target, privatePropName, {
      configurable: true,
      writable: true,
    });

    Object.defineProperty(target, propName, {
      get() {
        return this[privatePropName];
      },
      set(value: T) {
        this[privatePropName] = callback(value);
      },
    });
  }

  return propDecorator;
}

/** 延迟time时间后，将该属性置为flase */
export function BeFalseAfter(time = 1000) {
  return (target, propName) => {
    const privatePropName = `$__${propName}`;
    Object.defineProperty(target, privatePropName, {
      configurable: true,
      writable: true,
    });

    Object.defineProperty(target, propName, {
      get() {
        return target[privatePropName];
      },
      set(value: boolean) {
        target[privatePropName] = value;
        if (value) {
          const id = setTimeout(() => {
            target[privatePropName] = false;

            clearTimeout(id);
          }, time);
        }
      },
    });
  };
}

/**
 * 互斥
 * 即当propName为true的时候，otherField必须为false
 */
export function Mutex(otherField) {
  return (target, propName) => {
    const privatePropName = `$__${propName}`;

    Object.defineProperty(target, privatePropName, {
      configurable: true,
      writable: true,
    });

    Object.defineProperty(target, propName, {
      get() {
        return target[privatePropName];
      },
      set(value: boolean) {
        target[privatePropName] = value;
        if (value) {
          target[otherField] = !value;
        }
      },
    });
  };
}

export function Translate(i18nKey) {
  return (target, propName) => {
    const privatePropName = `$__${propName}`;

    Object.defineProperty(target, privatePropName, {
      configurable: true,
      writable: true,
    });

    Object.defineProperty(target, propName, {
      get() {
        const translate = InjectorService.injector.get(TranslateService);
        return translate.syncGet(i18nKey);
      },
    });
  };
}

export function Loading(field = 'loading') {
  return (target, prop, descriptor) => {
    const method = descriptor.value;
    descriptor.value = function () {
      this[field] = true;
      const subs: Subscription = method.apply(this, arguments);
      let id = setInterval(() => {
        if (!subs || (subs && subs.closed)) {
          this[field] = false;
          clearInterval(id);
          id = null;
        }
      }, 100);
    };
  };
}

export function WritePermissionGurd(permission) {
  return (target, prop, descriptor) => {
    const method = descriptor.value;

    descriptor.value = function () {
      const translate = InjectorService.injector.get(TranslateService);
      const authority = InjectorService.injector.get(AuthorityService);
      const modal = InjectorService.injector.get(NzModalService);

      if (!authority.hasWritePermission(permission)) {
        modal.warning({
          nzTitle: translate.syncGet('errorText.no_write_authority'),
        });
        return;
      }

      method.apply(this, arguments);
    };
  };
}

// /**
//  * @deprecated
//  * */
// export function FreeEditionUnsupportedWarning() {
//   return (target, prop, descriptor) => {
//     const method = descriptor.value;

//     descriptor.value = function () {
//       const member = InjectorService.injector.get(MemberService);

//       if (member.isFreeEdition()) {
//         member.freeEditionUnsupportedWarning();
//         return;
//       }

//       method.apply(this, arguments);
//     };
//   };
// }

export function OnLangChangeUntil(destroy: string) {
  return (target, prop, descriptor) => {
    const method = descriptor.value;

    descriptor.value = function () {
      const params = arguments;
      const translate = InjectorService.injector.get(TranslateService);
      const destroy$ = this[destroy] || target[destroy];

      translate
        .onLangChange()
        .pipe(takeUntil(destroy$))
        .subscribe((langChangeEvent) => {
          method.apply(this, params);
        });

      method.apply(this, arguments);
    };
  };
}

export function deprecatedMethod() {
  return (target, propertyKey, descriptor) => {
    const original = descriptor.value;

    descriptor.value = function (...args) {
      console.log(`Deprecation warning: ${propertyKey} is deprecated and will be removed in a future version`);
      const result = original.call(this, ...args);
      return result;
    };
  };
  // if (context.kind === 'method') {
  //   return function (...args: any[]) {
  //     console.warn(`${context.name.toString()} is deprecated and will be removed in a future version`);
  //     return target.apply(this, args);
  //   };
  // }
}

// export function deprecatedMethodv2(target, context) {
//   if (context.kind === 'method') {
//     return function (...args: any[]) {
//       console.warn(`${context.name.toString()} is deprecated and will be removed in a future version`);
//       return target.apply(this, args);
//     };
//   }
// }
